import { COLLECTION } from 'modules/catalog/actionTypePrefixes';

/** Create Collection Modal Actions */
export const SUBMIT_CREATE_MODAL = `${COLLECTION}/SUBMIT_CREATE_MODAL`;

export const OPEN_HANDLEBARS_MODAL = `${COLLECTION}/OPEN_HANDLEBARS_MODAL`;
export const CLOSE_HANDLEBARS_MODAL = `${COLLECTION}/CLOSE_HANDLEBARS_MODAL`;
export const COPY_HANDLEBARS = `${COLLECTION}/COPY_HANDLEBARS`;

export const SET_USES_SMART_RECOS_HANDLEBAR = `${COLLECTION}/SET_USES_SMART_RECOS_HANDLEBAR`;

export const DELETE_CATALOG_COLLECTION = `${COLLECTION}/DELETE_CATALOG_COLLECTION`;
export const DELETE_CATALOG_COLLECTION_RESPONSE = `${DELETE_CATALOG_COLLECTION}_RESPONSE`;
export const DELETE_CATALOG_COLLECTION_ERROR = `${DELETE_CATALOG_COLLECTION}_ERROR`;

export const OPEN_DELETE_MODAL = `${COLLECTION}/OPEN_DELETE_MODAL`;
export const CLOSE_DELETE_MODAL = `${COLLECTION}/CLOSE_DELETE_MODAL`;

export const FETCH_CATALOG_COLLECTIONS = `${COLLECTION}/FETCH_CATALOG_COLLECTIONS`;
export const FETCH_CATALOG_COLLECTIONS_RESPONSE = `${FETCH_CATALOG_COLLECTIONS}_RESPONSE`;
export const FETCH_CATALOG_COLLECTIONS_ERROR = `${FETCH_CATALOG_COLLECTIONS}_ERROR`;

export const FETCH_RECENT_CATALOG_COLLECTIONS = `${COLLECTION}/FETCH_RECENT_CATALOG_COLLECTIONS`;
